var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponsExchanged(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1159 6.09167H3.28255C2.90861 6.09167 2.60547 6.39482 2.60547 6.76876V8.12292C2.60547 8.49687 2.90861 8.80001 3.28255 8.80001H14.1159C14.4898 8.80001 14.793 8.49687 14.793 8.12292V6.76876C14.793 6.39482 14.4898 6.09167 14.1159 6.09167Z",
    stroke: "#00C49A",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69922 6.09167V14.8938",
    stroke: "#00C49A",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4391 8.80005V13.5396C13.4391 13.8988 13.2965 14.2432 13.0425 14.4972C12.7885 14.7511 12.4441 14.8938 12.085 14.8938H5.31413C4.95498 14.8938 4.61054 14.7511 4.35659 14.4972C4.10263 14.2432 3.95996 13.8988 3.95996 13.5396V8.80005",
    stroke: "#00C49A",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65267 6.09177C5.20374 6.09177 4.77319 5.91343 4.45574 5.59598C4.1383 5.27854 3.95996 4.84799 3.95996 4.39906C3.95996 3.95012 4.1383 3.51958 4.45574 3.20213C4.77319 2.88469 5.20374 2.70635 5.65267 2.70635C6.30584 2.69497 6.94592 3.01189 7.48942 3.61578C8.03292 4.21967 8.45463 5.08251 8.69954 6.09177C8.94446 5.08251 9.36617 4.21967 9.90967 3.61578C10.4532 3.01189 11.0932 2.69497 11.7464 2.70635C12.1954 2.70635 12.6259 2.88469 12.9433 3.20213C13.2608 3.51958 13.4391 3.95012 13.4391 4.39906C13.4391 4.84799 13.2608 5.27854 12.9433 5.59598C12.6259 5.91343 12.1954 6.09177 11.7464 6.09177",
    stroke: "#00C49A",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponsExchanged);
export default __webpack_public_path__ + "static/media/coupons-exchanged.dc05c2f97d95a32d50f654666c449369.svg";
export { ForwardRef as ReactComponent };